var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zfSuccessWrap"},[_c('div',{staticClass:"zfSuccessCon"},[_c('img',{attrs:{"src":require("../assets/success.png"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v("支付成功")]),_vm._v(" "),_c('button',[_vm._v("返回首页")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae4db0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/zfSuccess.vue
// module id = null
// module chunks = 